<template>
  <ion-header>
    <ion-toolbar class="ion-color topmenu">
      <ion-buttons slot="end">
        <ion-button
          v-if="user.id"
          color="light"
          @click="openClient()"
        >
          <ion-text
            class="icon-margin-right"
          >
            <template v-if="client.salutation">
              {{ client.salutation === 'mr' ? $t('general.salutation_mr') : $t('general.salutation_mrs') }} {{ client.customer_name }}
            </template>
            <template v-else>
              {{ $t('general.client_info') }}
            </template>
          </ion-text>
          <ion-icon
            :icon="person"
            size="small"
            class="icon-margin-right"
          />
        </ion-button>
        <ion-button
          color="light"
        >
          <ion-text>
            <a
              v-if="portal_url"
              :href="portal_url"
              target="_blank"
              rel="noopener noreferrer"
            >
              {{ $t('account.customer_portal') }}
              <ion-icon
                :icon="arrowForwardCircleOutline"
                size="small"
                class="icon-margin-left"
              />
            </a>
          </ion-text>
        </ion-button>
      </ion-buttons>
    </ion-toolbar>
    <slot />
  </ion-header>
</template>

<script>
import { defineComponent } from 'vue';
import store from '@/store';
import {
  IonHeader,
  IonButton,
  IonButtons,
  IonToolbar,
  modalController,
} from '@ionic/vue';
import {
  arrowForwardCircleOutline, person,
} from 'ionicons/icons';
import ClientModal from '@/components/ClientModal.vue';
import UserMixin from '@/mixins/UserMixin';

export default defineComponent({
  components: {
    IonHeader,
    IonButton,
    IonButtons,
    IonToolbar,
  },
  mixins: [UserMixin],
  setup() {
    return {
      arrowForwardCircleOutline, person,
    };
  },
  computed: {
    client() {
      return store.cart.client;
    },
  },
  methods: {
    /**
     * Open client modal.
     */
    async openClient() {
      const modal = await modalController
        .create({
          component: ClientModal,
        });

      // Present modal
      await modal.present();
    },
  },
});
</script>

<style scoped>
.topmenu {
  background-color: var(--ion-color-primary);

  a {
    display: flex;
    align-items: center;
    text-decoration: none;
  }
}
</style>
